import React from 'react';
import { CategoryFilterBar } from '../../components/CategoryFilterBar/CategoryFilterBar';
import {
    useDateSelection,
    useGetSelectedCategory,
    useReactQueryEnabler,
    useSingleToggle,
} from '../../components/CategoryFilterBar/hooks';
import { categoryMap } from '../../constants/dating';
import styles from './CategoryBar.module.scss';

export const CategoryBar = () => {
    const { dateSelection, changeDateSelection } = useDateSelection();
    const { enableQuery } = useReactQueryEnabler();
    const { setCategoryTag } = useGetSelectedCategory();
    const { handleToggled, selectedCategory } = useSingleToggle({
        categories: categoryMap,
        dateSelection,
    });

    return (
        <div className={styles.categoryBar}>
            <CategoryFilterBar
                categories={categoryMap}
                pageType="dating"
                enableQuery={enableQuery}
                dateSelection={dateSelection}
                changeDateSelection={changeDateSelection}
                enableDateFilter={true}
                setCategoryTag={setCategoryTag}
                handleToggled={handleToggled}
                selectedCategory={selectedCategory}
            />
        </div>
    );
};
